
class TableOfContents {
    constructor() {
        this.init();
        this.toggle();
    }

    init(){
        const post = document.querySelector('.post-detail');
        if (!post) return;

        const jsTableContents = post.querySelector('.js-table-of-contents');
        if (!jsTableContents) return;

        const headings = post.querySelectorAll('#article h1, #article h2, #article h3, #article h4, #article h5, #article h6')
        if (headings.length === 0) {
            jsTableContents.style.display = "none";
            return;
        }else{
            jsTableContents.style.display = "";
            jsTableContents.style.opacity = "";
        }

        const tocContainers = document.querySelectorAll('.contentsTOC')
        tocContainers.forEach(tocContainer => {
            const startingLevel = headings[0].tagName[1]
    
            const toc = document.createElement('ul')
            const prevLevels = [0, 0, 0, 0, 0, 0]
    
            for (let i = 0; i < headings.length; i++) {
                const heading = headings[i]
    
                if (!heading.textContent){
                    continue;
                }
    
                const level = parseInt(heading.tagName[1])
    
                prevLevels[level - 1]++
                for (let j = level; j < prevLevels.length; j++) {
                    prevLevels[j] = 0
                }
    
                // const sectionNumber = prevLevels.slice(startingLevel - 1, level).join('.').replace(/\.0/g, "")
                const newHeadingId = `id-${heading.textContent.toLowerCase().replace(/[^\w\s-]/g, '').trim().replace(/ /g, '-')}`
                heading.id = newHeadingId
    
                const anchor = document.createElement('a')
                anchor.setAttribute('href', `#${newHeadingId}`)
                anchor.textContent = heading.textContent
    
                anchor.addEventListener('click', (event) => {
                    event.preventDefault();
    
                    const targetId = event.target.getAttribute('href').slice(1)
                    const targetElement = document.getElementById(targetId)
                    let offsetTop = getOffsetTop(targetElement);
                    
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    })
                    history.pushState(null, null, `#${targetId}`)
                })
    
                const listItem = document.createElement('li')
                listItem.appendChild(anchor)
    
                const className = `contents-${heading.tagName.toLowerCase()}`
                listItem.classList.add('contents-item')
                listItem.classList.add(className)
    
                toc.appendChild(listItem)
                tocContainer.innerHTML = ''
                tocContainer.appendChild(toc)
        
                window.addEventListener('scroll', function () {
                    let scroll = window.scrollY
                    let height = window.innerHeight
                    let offset = 200;
        
                    headings.forEach(function (heading, index) {
                        let i = index + 1
                        let target = tocContainer.querySelector('li:nth-of-type(' + i + ') > a')
                        let pos = heading.getBoundingClientRect().top + scroll
                        if (!target) return
        
                        if (scroll > pos - height + offset) {
                            if (headings[index + 1] !== undefined) {
                                let next_pos = headings[index + 1].getBoundingClientRect().top + scroll
                                if (scroll > next_pos - height + offset) {
                                    target.classList.remove('contents-active')
                                } else if (i === 1 && tocContainer.classList.contains('active') === false) {
                                    target.classList.add('contents-active')
                                    tocContainer.classList.add('active')
                                } else {
                                    target.classList.add('contents-active')
                                }
                            } else {
                                target.classList.add('contents-active')
                            }
                        } else {
                            target.classList.remove('contents-active')
                            if (i === 1 && tocContainer.classList.contains('active')) {
                                tocContainer.classList.remove('active')
                            }
                        }
                    })
                })
            }
        })


        function getOffsetTop(element) {
            const rect = element.getBoundingClientRect();
            let space = rect.height;
            // let header = document.querySelector('.header');
            // if (header){
            //     return rect.top + window.scrollY - header.clientHeight - space;
            // }
            return rect.top + window.scrollY - space;
        }
    }

    toggle(){
        const contents = document.querySelectorAll('.js-table-of-contents')
        contents.forEach(contentItem => {
            const toggleBtn = contentItem.querySelector('.contents-toggle');
            const contentsTOC = contentItem.querySelector('.contentsTOC');
            if (!contentsTOC || !toggleBtn){
                return;
            }

            if (window.innerWidth < 1024){
                this.jquerySlideUp(contentsTOC);
                toggleBtn.classList.remove('showed');
            }
            else{
                contentsTOC.style.display = "";
                toggleBtn.classList.add('showed');
            }
        
            toggleBtn?.addEventListener('click', (e) => {
                e.preventDefault();
                
                toggleBtn.classList.toggle('showed');
    
                if (toggleBtn.classList.contains('showed')){
                    this.jquerySlideDown(contentsTOC);
                }else{
                    this.jquerySlideUp(contentsTOC);
                }
            })
        })
    }

    jquerySlideDown(element, duration = 250) {
        jQuery(element).stop(true, true).slideDown(duration);
    }

    jquerySlideUp(element, duration = 250) {
        jQuery(element).stop(true, true).slideUp(duration);
    }
}

export default TableOfContents;